import _camelCase from 'lodash/camelCase';
import { ServiceChipFilter, ServiceTypes } from '../types/types.js';

function getChipFilteredServices(services, chipFilter) {
  switch (chipFilter) {
    case ServiceChipFilter.ALL:
      return services;
    case ServiceChipFilter.CONTRACTS:
      return services.filter(service => !!service.isOwnContract);
    default:
      return services.filter(service => service.category === chipFilter);
  }
}
function getSidePanelFilteredServices(services, sidePanelFilters) {
  const {
    carriers,
    collectionTypes,
    deliveryTypes,
    serviceDetails,
    transitHours,
    tagTypes
  } = sidePanelFilters;
  const filteredServices = [];
  const hasSomeCarrier = Object.values(carriers).some(value => value);
  const hasSomeCollectionType = Object.values(collectionTypes).some(value => value);
  const hasSomeDeliveryType = Object.values(deliveryTypes).some(value => value);
  const hasSomeServiceDetail = Object.values(serviceDetails).some(value => value);
  const serviceDetailsKeys = Object.keys(serviceDetails).filter(details => serviceDetails[details]);
  const hasSomeTransitHours = Object.values(transitHours).some(value => value);
  const hasSomeTagTypes = Object.values(tagTypes).some(value => value);
  services.forEach(service => {
    if (hasSomeCarrier && !(service.carrierName && carriers[_camelCase(service.carrierName)])) {
      return;
    }
    if (hasSomeCollectionType) {
      var _service$dropOff;
      const collectionKey = (_service$dropOff = service.dropOff) !== null && _service$dropOff !== void 0 && _service$dropOff.origin ? ServiceTypes.DROPOFF : ServiceTypes.COLLECTION;
      if (!collectionTypes[_camelCase(collectionKey)]) {
        return;
      }
    }
    if (hasSomeDeliveryType) {
      var _service$dropOff2;
      const deliveryKey = (_service$dropOff2 = service.dropOff) !== null && _service$dropOff2 !== void 0 && _service$dropOff2.destination ? ServiceTypes.PICKUP : ServiceTypes.DELIVERY;
      if (!deliveryTypes[_camelCase(deliveryKey)]) {
        return;
      }
    }
    if (hasSomeServiceDetail && !serviceDetailsKeys.some(detail => {
      var _service$serviceInfo;
      return (_service$serviceInfo = service.serviceInfo) === null || _service$serviceInfo === void 0 ? void 0 : _service$serviceInfo.some(info => (info === null || info === void 0 ? void 0 : info.text) && _camelCase(info.text) === detail);
    })) {
      return;
    }
    if (hasSomeTransitHours && !(service.transitHours && transitHours[service.transitHours.toString()])) {
      return;
    }
    if (hasSomeTagTypes && !service.tags.some(tag => tag.id && tagTypes[tag.id])) {
      return;
    }
    filteredServices.push(service);
  });
  return filteredServices;
}
function getComputedChipFilters(services) {
  const computedChipFilters = Array.from(new Set(services.filter(service => !!service.category).map(service => service.category)));
  const hasOwnContract = services.some(service => service.isOwnContract);
  if (hasOwnContract) {
    computedChipFilters.unshift(ServiceChipFilter.CONTRACTS);
  }
  const computedChipFiltersLength = computedChipFilters.length;
  if (computedChipFiltersLength > 1) {
    computedChipFilters.unshift(ServiceChipFilter.ALL);
  }

  // if we only have 1 filter then there is no need to show the chip
  return computedChipFiltersLength === 1 ? undefined : computedChipFilters;
}
const getLengthValues = obj => Object.values(obj).filter(value => value).length;

export { getChipFilteredServices, getComputedChipFilters, getLengthValues, getSidePanelFilteredServices };
//# sourceMappingURL=Filters.js.map
